import React, { PropsWithChildren, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { CodeListItem } from 'app/area/codetable/list/types-store';
import { CodeDragItemType } from 'app/area/codetable/list/constants';
import {
  changeAppNavbarPosition, removeAppNavbarPostion
} from 'app/area/codetable/list/list-items/drag-and-drop/change-app-navbar-position';
import styles from './code-drag.scss';

interface CodeDragProps {
  item: CodeListItem;
  type: CodeDragItemType;
}

export const CodeDrag = ({
  item, type, children
}: PropsWithChildren<CodeDragProps>) => {

  const [collected, dragRef, preview] =
    useDrag({
      type,
      item,
      collect: (monitor) => ({
        isDragging: monitor.isDragging()
      }),
      end() {
        changeAppNavbarPosition('fixed');
      }
    });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });

    return () => {
      removeAppNavbarPostion();
    };
  }, []);

  if (collected.isDragging) {
    changeAppNavbarPosition('relative');
  }

  return <div
    ref={dragRef}
    className={collected.isDragging ? styles.draggedItem : ''}>
    {children}
  </div>;
};
